import React from "react"
import { useRecoilState } from "recoil"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"

import SelectField from "../components/SelectField"
import StepButtons from "../components/StepButtons"
import TextField from "../components/TextField"
import positionOptions from "../libs/positions"
import onboardingProgress from "../store/onboardingProgress"

export default function AssociationInfo() {
  const [progress, setProgress] = useRecoilState(onboardingProgress)

  return (
    <Formik
      initialValues={{
        name: progress.association.name,
        email: progress.association.email,
        phone: progress.association.phone,
        position: progress.user.position,
        unit: progress.user.unit,
      }}
      validationSchema={Yup.object().shape({
        name: Yup.string().required("Name required"),
        email: Yup.string().email("Please enter a valid email"),
        phone: Yup.string().matches(
          /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)$/,
          "Please enter a valid phone number"
        ),
        position: Yup.string()
          .oneOf(positionOptions.map((position) => position.value))
          .required("Please provide your position"),
        unit: Yup.string().required("Unit required"),
      })}
      onSubmit={(values) => {
        setProgress({
          ...progress,
          activeStep: progress.activeStep + 1,
          association: {
            ...progress.association,
            ...values,
          },
        })
      }}
    >
      {({ errors, handleBlur, isSubmitting, isValid, touched, values, setFieldValue }) => {
        const handleChange = (event) => {
          setFieldValue(event.target.name, event.target.value)
          setProgress({
            ...progress,
            association: {
              ...progress.association,
              [event.target.name]: event.target.value,
            },
          })
        }
        return (
          <Form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography>Address: {progress.association.addressFull}</Typography>
              </Grid>
              <Grid item md={12}>
                <TextField
                  autoFocus
                  error={Boolean(touched.name && errors.name)}
                  helperText={touched.name && errors.name}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.name}
                  label="Association Name"
                  name="name"
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  error={Boolean(touched.email && errors.email)}
                  helperText={touched.email && errors.email}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.email}
                  label="Association Email"
                  name="email"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  error={Boolean(touched.phone && errors.phone)}
                  helperText={touched.phone && errors.phone}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.phone}
                  label="Association Phone"
                  name="phone"
                />
              </Grid>
              <Grid item xs={12}>
                <SelectField
                  error={Boolean(touched.position && errors.position)}
                  helperText={touched.position && errors.position}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.position}
                  label="Your Position"
                  name="position"
                  options={positionOptions}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.unit && errors.unit)}
                  helperText={touched.unit && errors.unit}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.unit}
                  label="Your Unit Number"
                  name="unit"
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} justifyContent="flex-end">
              <Grid item xs={12}>
                <StepButtons disableNext={!isValid} isLoading={isSubmitting} />
              </Grid>
            </Grid>

            <div style={{ clear: "both", content: "", display: "block" }}></div>
          </Form>
        )
      }}
    </Formik>
  )
}
